import React, {useEffect, useState} from 'react';
import SystemContext from '../contexts/system-context';


export function SystemProvider(props) {
    const [messageType, setMessageType] = useState('error');
    const [message, changeMessage] = useState('');
    const [modal, setModal] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [processStages, setProcessStages] = useState([]);
    const [showConfetti, setShowConfetti] = useState(false);
    const [solved, setSolved] = useState(false);
    const [user, setUser] = useState(null);

    const setMessage = (type = 'error') => (message) => {
        changeMessage(message);
        setMessageType(type);

        setTimeout(() => {
            changeMessage('');
        }, 5000);
    };

    const showModal = (name = 'error', data = {}, onClose) => {
        setModal({
            name,
            data: {
                ...data,
                onClose: () => {
                    setModalVisible(false);
                    setTimeout(() => setModal('', {}), 300)
                    onClose && onClose();
                },
            },
        });
        setModalVisible(true)
        document.body.classList.add()
    };


    const val = {
        processStages,
        messageType,
        message,
        modal,
        modalVisible,
        setModalVisible,
        user,
        showConfetti,
        solved,
        setSolved,
        setShowConfetti,
        setUser,
        setMessage: setMessage('message'),
        setError: setMessage('error'),
        setSuccess: setMessage('success'),
        setProcessStages,
        showModal,
    };

    return <SystemContext.Provider value={val} {...props} />;
}

export const useSystem = () => {
    const context = React.useContext(SystemContext);

    if (!context) {
        throw new Error('must be used with SystemProvider');
    }

    return {
        ...context,
    };
};
